<!--
    Name:			PauseDetail.vue

    Description:	Show the pause overlay.

    Remarks:
-->

<template>
    <div >
        <div class="pauzedetail accent-background panel">
            <div class="panel">                
                <img src="/img/logo-ordergo.svg" />
            </div>
        </div>
        <div class="content-in">
            <div class="panel">
                <div class="swal2-icon swal2-info swal2-animate-info-icon" style="display: flex;"></div>
                <h1><translate item="TimelineSettings.ModifyTime.Pause" /></h1>
                <p><translate item="TimelineSettings.ModifyTime.TimelineIsPaused" /></p>
            </div>
        </div>
        <br /><br />
        <div class="panel text-center">
            <div class="text-center">
                <div class="btn btn-dark" v-on:click="close"><translate item="General.Close" /></div>
            </div>
        </div>
    </div>
</template>

<script>

    import translate from '../components/translate'
    import Swal from "sweetalert2";

    let options = {
        //weekday: "long", year: "numeric", month: "short",
        //day: "numeric",
        hour: "2-digit", minute: "2-digit"
    };

    const batchDetail = {

        components: { translate },

        created: function () {

            //alert('orderdetail');
        },

        methods: {
            close: function () {
                Swal.close();
            }
        }
    };

    export { batchDetail as default };

</script>

<style>
    .pauzedetail img{
        width:60%;
    }
</style>
